import { render, staticRenderFns } from "./editDepartmentGroup.vue?vue&type=template&id=36954336&scoped=true&"
import script from "./editDepartmentGroup.vue?vue&type=script&lang=js&"
export * from "./editDepartmentGroup.vue?vue&type=script&lang=js&"
import style0 from "./editDepartmentGroup.vue?vue&type=style&index=0&id=36954336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36954336",
  null
  
)

export default component.exports